// Whether the left menu is open on a phone (on a wide screen it is always shown).
import { create } from 'zustand'

interface SidebarState {
  open: boolean
  setOpen: (open: boolean) => void
}

export const useSidebar = create<SidebarState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}))
